import Vue from 'vue'
import Router from 'vue-router'
import Main from "@/pages/main";
import Page2 from "@/pages/page2";
import Menu1 from "@/pages/menu1"
import Menu1Imagesscence from "@/pages/menu1_images_scence"
import Menu1ImagesscenceQ from "@/pages/menu1_images_scence_q"
import Menu1VideoClipQ from "@/pages/menu1_video_clip_q"
import Menu1VideoClip from "@/pages/menu1_video_clip"
import Menu1ActiveLearning from "@/pages/menu1_active_learning"
import Menu2 from "@/pages/menu2"
import Menu2Imagesscence from "@/pages/menu2_images_scence"
import Menu2ImagesscenceQ from "@/pages/menu2_images_scence_q"
import Menu2VideoClipQ from "@/pages/menu2_video_clip_q"
import Menu2VideoClip from "@/pages/menu2_video_clip"
import Menu2ActiveLearning from "@/pages/menu2_active_learning"
import Menu3 from "@/pages/menu3"
import Menu3Imagesscence from "@/pages/menu3_images_scence"
import Menu3ImagesscenceQ from "@/pages/menu3_images_scence_q"
import Menu3VideoClipQ from "@/pages/menu3_video_clip_q"
import Menu3VideoClip from "@/pages/menu3_video_clip"
import Menu3ActiveLearning from "@/pages/menu3_active_learning"
import Menu4 from "@/pages/menu4"
import Menu4Imagesscence from "@/pages/menu4_images_scence"
import Menu4ImagesscenceQ from "@/pages/menu4_images_scence_q"
import Menu4VideoClipQ from "@/pages/menu4_video_clip_q"
import Menu4VideoClip from "@/pages/menu4_video_clip"
import Menu4ActiveLearning from "@/pages/menu4_active_learning"
import Menu5 from "@/pages/menu5"
import Menu5Imagesscence from "@/pages/menu5_images_scence"
import Menu5ImagesscenceQ from "@/pages/menu5_images_scence_q"
import Menu5VideoClipQ from "@/pages/menu5_video_clip_q"
import Menu5VideoClip from "@/pages/menu5_video_clip"
import Menu5ActiveLearning from "@/pages/menu5_active_learning"
import ltr from "@/pages/ltr";
import Index from "@/pages/index";
import Navbarblog from "@/components/navbarblog";

// blog pages
import Bloglist from "@/demo_pages/blog_list";
import Blogdetails from "@/demo_pages/blog_details";
import Blogsleftside from "@/demo_pages/blogs_leftside";
import Blogsrightside from "@/demo_pages/blogs_rightside";
import Blogleftsidebar from "@/demo_pages/blog_details_left_sidebar";
import Blogrightsidebar from "@/demo_pages/blog_details_right_sidebar";
import Pagenotfound from "@/other_pages/pagenotfound";
// Other pages
import Signup from "@/other_pages/signup";
import Signin from "@/other_pages/signin";
import Forgotpassword from "@/other_pages/forgot_password";
import Thankyou from "@/other_pages/thank_you";
import Review from "@/other_pages/review";
import FAQpage from "@/other_pages/FAQ_page";
import Comingsoon from "@/other_pages/coming_soon";
import Downloadpage from "@/other_pages/download";
import Request from "@/other_pages/request";

/* *******rtl paghes **********/
import Indexrtl from "@/rtl/pages/Indexrtl";
import rtl from "@/pages/rtl";
import Navbarrtl from "@/rtl/components/navbar";
import Navbarblogrtl from "@/rtl/components/navbarblog.vue";

Vue.use(Router)
export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
 
    {
      path: "/",
      name: "Main_page",
      components: {
        default: Main,
      },
    },
    {
      path: "/menu",
      name: "Menu",
      components: {
        default:Page2,
      },
    },
    {
      path: "/menu1",
      name: "Menu1",
      components: {
        default:Menu1,
      },
    },
    {
      path: "/menu1-images-scence",
      name: "Menu1Imagesscence",
      components: {
        default:Menu1Imagesscence,
      },
    },
    {
      path: "/menu1-images-scence-q",
      name: "Menu1ImagesscenceQ",
      components: {
        default:Menu1ImagesscenceQ,
      },
    },
    {
      path: "/menu1-video-clip-q",
      name: "Menu1VideoClipQ",
      components: {
        default:Menu1VideoClipQ,
      },
    },
    {
      path: "/menu1-video-clip",
      name: "Menu1VideoClip",
      components: {
        default:Menu1VideoClip,
      },
    },
    {
      path: "/menu1-active-learning",
      name: "Menu1ActiveLearning",
      components: {
        default:Menu1ActiveLearning,
      },
    },
    {
      path: "/menu2",
      name: "Menu2",
      components: {
        default:Menu2,
      },
    },
    {
      path: "/menu2-images-scence",
      name: "Menu2Imagesscence",
      components: {
        default:Menu2Imagesscence,
      },
    },
    {
      path: "/menu2-images-scence-q",
      name: "Menu2ImagesscenceQ",
      components: {
        default:Menu2ImagesscenceQ,
      },
    },
    {
      path: "/menu2-video-clip-q",
      name: "Menu2VideoClipQ",
      components: {
        default:Menu2VideoClipQ,
      },
    },
    {
      path: "/menu2-video-clip",
      name: "Menu2VideoClip",
      components: {
        default:Menu2VideoClip,
      },
    },
    {
      path: "/menu2-active-learning",
      name: "Menu2ActiveLearning",
      components: {
        default:Menu2ActiveLearning,
      },
    },
    {
      path: "/menu3",
      name: "Menu3",
      components: {
        default:Menu3,
      },
    },
    {
      path: "/menu3-images-scence",
      name: "Menu3Imagesscence",
      components: {
        default:Menu3Imagesscence,
      },
    },
    {
      path: "/menu3-images-scence-q",
      name: "Menu3ImagesscenceQ",
      components: {
        default:Menu3ImagesscenceQ,
      },
    },
    {
      path: "/menu3-video-clip-q",
      name: "Menu3VideoClipQ",
      components: {
        default:Menu3VideoClipQ,
      },
    },
    {
      path: "/menu3-video-clip",
      name: "Menu3VideoClip",
      components: {
        default:Menu3VideoClip,
      },
    },
    {
      path: "/menu3-active-learning",
      name: "Menu3ActiveLearning",
      components: {
        default:Menu3ActiveLearning,
      },
    },
    {
      path: "/menu4",
      name: "Menu4",
      components: {
        default:Menu4,
      },
    },
    {
      path: "/menu4-images-scence",
      name: "Menu4Imagesscence",
      components: {
        default:Menu4Imagesscence,
      },
    },
    {
      path: "/menu4-images-scence-q",
      name: "Menu4ImagesscenceQ",
      components: {
        default:Menu4ImagesscenceQ,
      },
    },
    {
      path: "/menu4-video-clip-q",
      name: "Menu4VideoClipQ",
      components: {
        default:Menu4VideoClipQ,
      },
    },
    {
      path: "/menu4-video-clip",
      name: "Menu4VideoClip",
      components: {
        default:Menu4VideoClip,
      },
    },
    {
      path: "/menu4-active-learning",
      name: "Menu4ActiveLearning",
      components: {
        default:Menu4ActiveLearning,
      },
    },
    {
      path: "/menu5",
      name: "Menu5",
      components: {
        default:Menu5,
      },
    },
    {
      path: "/menu5-images-scence",
      name: "Menu5Imagesscence",
      components: {
        default:Menu5Imagesscence,
      },
    },
    {
      path: "/menu5-images-scence-q",
      name: "Menu5ImagesscenceQ",
      components: {
        default:Menu5ImagesscenceQ,
      },
    },
    {
      path: "/menu5-video-clip-q",
      name: "Menu5VideoClipQ",
      components: {
        default:Menu5VideoClipQ,
      },
    },
    {
      path: "/menu5-video-clip",
      name: "Menu5VideoClip",
      components: {
        default:Menu5VideoClip,
      },
    },
    {
      path: "/menu5-active-learning",
      name: "Menu5ActiveLearning",
      components: {
        default:Menu5ActiveLearning,
      },
    },
    {
      path: "/404",
      name: "pagenotfound",
      component: Pagenotfound,
    },
    {
      // path: "*",
      path: "/:pathMatch(.*)*",
      redirect: "/404",
    },
    {
      path: "/",
      // You could also have named views at the top
      components: {
        default: ltr,
      },
      children: [
        {
          path: "index",
          name: "Index",
          components: {
            default: Index,
            // navbar: Navbar,
          },
        },
        {
          path: "blog-list",
          name: "Bloglist",
          components: {
            default: Bloglist,
            navbar: Navbarblog,
          },
        },
        {
          path: "blog-details",
          name: "Blogdetails",
          components: {
            default: Blogdetails,
            navbar: Navbarblog,
          },
        },
        {
          path: "blogs-leftside",
          name: "Blogsleftside",
          components: {
            default: Blogsleftside,
            navbar: Navbarblog,
          },
        },
        {
          path: "blogs-rightside",
          name: "Blogsrightside",
          components: {
            default: Blogsrightside,
            navbar: Navbarblog,
          },
        },
        {
          path: "blog-details-with-left-sidebar",
          name: "Blogleftsidebar",
          components: {
            default: Blogleftsidebar,
            navbar: Navbarblog,
          },
        },
        {
          path: "blog-details-with-right-sidebar",
          name: "Blogrightsidebar",
          components: {
            default: Blogrightsidebar,
            navbar: Navbarblog,
          },
        },
        {
          path: "sign-up",
          name: "Signup",
          component: Signup,
        },
        {
          path: "sign-in",
          name: "Signin",
          component: Signin,
        },
        {
          path: "forgot-password",
          name: "Forgotpassword",
          component: Forgotpassword,
        },
        {
          path: "review",
          name: "Review",
          components: {
            default: Review,
            navbar: Navbarblog,
          },
        },
        {
          path: "thank-you",
          name: "Thankyou",
          component: Thankyou,
        },
        {
          path: "FAQ-page",
          name: "FAQpage",
          components: {
            default: FAQpage,
            navbar: Navbarblog,
          },
        },
        {
          path: "download",
          name: "Downloadpage",
          component: Downloadpage,
        },
        {
          path: "coming-soon",
          name: "Comingsoon",
          component: Comingsoon,
        },
        {
          path: "request",
          name: "Request",
          components: {
            default: Request,
            navbar: Navbarblog,
          },
        },
      ],
    },
    // rtl strat form hear
    {
      path: "//rtl",
      components: {
        default: rtl,
      },
      children: [
        {
          path: "",
          name: "Indexrtl",
          components: {
            default: Indexrtl,
            navbar: Navbarrtl,
          },
        },
        {
          path: "blog-list",
          name: "Bloglistrtl",
          components: {
            default: Bloglist,
            navbar: Navbarblogrtl,
          },
        },
        {
          path: "blog-details",
          name: "Blogdetailsrtl",
          components: {
            default: Blogdetails,
            navbar: Navbarblogrtl,
          },
        },
        {
          path: "blogs-leftside",
          name: "Blogsleftsidertl",
          components: {
            default: Blogsleftside,
            navbar: Navbarblogrtl,
          },
        },
        {
          path: "blogs-rightside",
          name: "Blogsrightsidertl",
          components: {
            default: Blogsrightside,
            navbar: Navbarblogrtl,
          },
        },
        {
          path: "blog-details-with-left-sidebar",
          name: "Blogleftsidebarrtl",
          components: {
            default: Blogleftsidebar,
            navbar: Navbarblogrtl,
          },
        },
        {
          path: "blog-details-with-right-sidebar",
          name: "Blogrightsidebarrtl",
          components: {
            default: Blogrightsidebar,
            navbar: Navbarblogrtl,
          },
        },
        {
          path: "sign-up",
          name: "Signuprtl",
          component: Signup,
        },
        {
          path: "sign-in",
          name: "Signinrtl",
          component: Signin,
        },
        {
          path: "forgot-password",
          name: "Forgotpasswordrtl",
          component: Forgotpassword,
        },
        {
          path: "review",
          name: "Reviewrtl",
          components: {
            default: Review,
            navbar: Navbarblogrtl,
          },
        },
        {
          path: "thank-you",
          name: "Thankyourtl",
          component: Thankyou,
        },
        {
          path: "FAQ-page",
          name: "FAQpagertl",
          components: {
            default: FAQpage,
            navbar: Navbarblog,
          },
        },
        {
          path: "download",
          name: "Downloadpagertl",
          component: Downloadpage,
        },
        {
          path: "coming-soon",
          name: "Comingsoonrtl",
          component: Comingsoon,
        },
        {
          path: "request",
          name: "Requestrtl",
          components: {
            default: Request,
            navbar: Navbarblog,
          },
        },
        {
          path: "404",
          name: "Pagenotfoundrtl",
          component: Pagenotfound,
        },
      ],
    },
  ]
})
